import race_start_order_channel from 'channels/race_start_order_channel'
import process_people_performances_channel from 'channels/process_people_performances_channel'
import race_ranking_channel from 'channels/race_ranking_channel'
import race_performances_channel from 'channels/race_performances_channel'
import race_queue_channel from 'channels/race_queue_channel'

//// Load all the channels within this directory and all subdirectories.
//// Channel files must be named *_channel.js.
//
//const channels = require.context('.', true, /_channel\.js$/)
//channels.keys().forEach(channels)

const Channels = {
  race_start_order_channel,
  process_people_performances_channel,
  race_ranking_channel,
  race_performances_channel,
  race_queue_channel,
}

export default Channels
